const translations = require("../data/translations.json");

module.exports = (themeOptions) => ({
  actionButtonLink: "about/contact",
  colors: {
    primary: "#ff5400",
    primary_transparent: "#ff54009c",
    light: "#ffffff",
    dark: "#000000",
    bg: "#f5f5f5"
  },
  customHeaderNavItems: [],
  dataPath: `${__dirname}/data`,
  footerLinks: [
    { title: "about", to: "about" },
    { title: "contact", to: "about/contact" },
    { title: "press", to: "about/press" },
    { title: "privacy", to: "about/privacy" }
  ],
  homepageSupportButtonLink: "",
  locales: ["en", "ar"],
  otherArchives: [
    { name: "syrian archive", link: "https://syrianarchive.org" },
    { name: "sudanese archive", link: "https://sudanesearchive.org" },
    { name: "yemeni archive", link: "https://yemeniarchive.org" },
    { name: "ukrainian archive", link: "https://ukrainianarchive.org" }
  ],
  socialMediaLinks: [
    { type: "facebook", link: "https://facebook.com" },
    { type: "twitter", link: "https://twitter.com" },
    { type: "instagram", link: "https://instagram.com" },
  ],
  title: "Test Archive",
  translations,
  workflowDiagramCounts: {
    collect: "42",
    preserve: "42",
    process: "42",
    verify: "42",
    investigate: "42",
  },
  ...themeOptions,
});
